(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partial_announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if($('.marquee').length) {
    Marquee3k.init({
      selector: 'marquee',
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partial_related-products"]) return;
  try {
    
  window.onload = () => {
    const productRecommendationsSection = document.querySelector('.related-products-container');
    if (!productRecommendationsSection) return;

    const url = productRecommendationsSection.dataset.url;
    if (!url) return;

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.related-products-container');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(e => {
      console.error(e);
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_chat"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const chatSwiper = new Swiper('#chat-swiper', {
    loop: true,
    speed: 800,
    slidesPerView: 1,
    breakpoints: {
      500: {
        slidesPerView: 1.75
      },
      1200: {
        slidesPerView: 2
      }
    },
    grabCursor: true,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
      dynamicBullets: true,
    },
  });

  // Handle message form submission
  const messageForm = document.getElementById('message-chat-form');
  const messageFormInput = document.getElementById('message-form-input');
  const contactForm = document.getElementById('contact_form');
  const messageInput = document.getElementById('message');
  const emailInput = document.getElementById('email');

  if (messageForm) {
    messageForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Copy value from message-form-input to message
      if (messageFormInput && messageInput) {
        messageInput.value = messageFormInput.value;
      }
      
      // Add show class to contact form
      if (contactForm) {
        messageForm.style.display = 'none';
        contactForm.classList.add('show');
      }

      // Focus on email input
      if (emailInput) {
        emailInput.focus();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_index"]) return;
  try {
    
// Reset scroll position immediately
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

document.addEventListener('DOMContentLoaded', function() {
console.log('Loaded');
// Ensure scroll is at top on load
window.scrollTo(0, 0);

const myCustomSlider = document.querySelectorAll('.module-homepage-swiper');
const delayOptions = [3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500];
const usedDelays = [];

for( var i=0; i< myCustomSlider.length; i++ ) {
    (function(index) {
      var currentSlider = myCustomSlider[index];
      console.log(currentSlider, 'Loaded:', index);
    
      currentSlider.classList.add('module-homepage-swiper-' + index);
      
      // Count slides
      var slideCount = currentSlider.querySelectorAll('.swiper-slide').length;
      
      // Get random delay that hasn't been used
      var availableDelays = delayOptions.filter(function(delay) {
        return usedDelays.indexOf(delay) === -1;
      });
      
      // If all delays have been used, reset
      if (availableDelays.length === 0) {
        usedDelays.length = 0;
        availableDelays = delayOptions.slice();
      }
      
      var randomDelay = availableDelays[Math.floor(Math.random() * availableDelays.length)];
      usedDelays.push(randomDelay);
      
      // Create progress bar only if more than one slide
      if (slideCount > 1) {
        var progressBar = document.createElement('div');
        progressBar.className = 'swiper-progress-bar';
        var progressFill = document.createElement('div');
        progressFill.className = 'swiper-progress-fill';
        progressBar.appendChild(progressFill);
        currentSlider.appendChild(progressBar);
      }

    var slider = new Swiper(currentSlider, {
      loop: slideCount > 1,
      speed: 400,
      // navigation: {
      //   nextEl: currentSlider
      // },
      effect: "cube",
      cubeEffect: {
        shadow: false,
        slideShadows: true,
        shadowOffset: 20,
        shadowScale: 0.5,
      },
      autoplay: slideCount > 1 ? {
        delay: randomDelay,
        disableOnInteraction: false,
      } : false,
      on: {
        autoplayTimeLeft: function(swiper, time, percentage) {
          var progressFill = swiper.el.querySelector('.swiper-progress-fill');
          if (progressFill) {
            progressFill.style.width = (100 - percentage * 100) + '%';
          }
        },
        slideChangeTransitionStart: function(swiper) {
          var progressFill = swiper.el.querySelector('.swiper-progress-fill');
          if (progressFill) {
            progressFill.style.width = '0%';
          }
        }
      }
    });
  })(i);
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_innerworld"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const entries = document.querySelectorAll('.innerworld-entry');
  const colorFilters = document.querySelectorAll('#innerworld-filters-colors .filter');
  const emotionFilters = document.querySelectorAll('#innerworld-filters-emotions .filter');
  const currentEmotionSpan = document.querySelector('.current-emotion');
  
  let activeColor = 'all';
  let activeEmotion = 'all';
  
  // Color filter functionality
  colorFilters.forEach(function(filter) {
    filter.addEventListener('click', function() {
      const isAll = filter.classList.contains('all');
      const filterValue = filter.getAttribute('data-value');
      const isActive = filter.classList.contains('active');
      
      if (isAll) {
        // Always activate 'All' if clicked
        colorFilters.forEach(function(f) {
          f.classList.remove('active');
        });
        filter.classList.add('active');
        activeColor = 'all';
      } else if (isActive) {
        // If already active, deactivate it and go back to 'All'
        filter.classList.remove('active');
        const allFilter = document.querySelector('#innerworld-filters-colors .filter.all');
        if (allFilter) {
          allFilter.classList.add('active');
        }
        activeColor = 'all';
      } else {
        // Remove active class from all color filters
        colorFilters.forEach(function(f) {
          f.classList.remove('active');
        });
        
        // Add active class to clicked filter
        filter.classList.add('active');
        activeColor = filterValue;
      }
      
      // Apply filters
      applyFilters();
    });
  });
  
  // Emotion filter functionality
  const emotionsContainer = document.getElementById('innerworld-filters-emotions');
  const emotionsTrigger = document.getElementById('emotions-trigger');
  
  emotionFilters.forEach(function(filter) {
    filter.addEventListener('click', function() {
      const filterText = filter.textContent;
      const filterValue = filter.getAttribute('data-value');
      const isActive = filter.classList.contains('active');
      
      if (isActive) {
        // If already active, deactivate it
        filter.classList.remove('active');
        activeEmotion = 'all';
        if (currentEmotionSpan) {
          currentEmotionSpan.textContent = 'All';
        }
      } else {
        // Remove active class from all emotion filters
        emotionFilters.forEach(function(f) {
          f.classList.remove('active');
        });
        
        // Add active class to clicked filter
        filter.classList.add('active');
        activeEmotion = filterValue;
        
        // Update current emotion text
        if (currentEmotionSpan) {
          currentEmotionSpan.textContent = filterText;
        }
      }
      
      // Apply filters
      applyFilters();
    });
  });
  
  // Reset emotions to 'All' when closing
  // if (emotionsTrigger) {
  //   emotionsTrigger.addEventListener('click', function() {
  //     // Use setTimeout to check after the class toggle happens
  //     setTimeout(function() {
  //       const isShowing = emotionsContainer && emotionsContainer.classList.contains('show');
        
  //       if (!isShowing) {
  //         // Just closed - reset to All
  //         emotionFilters.forEach(function(f) {
  //           f.classList.remove('active');
  //         });
  //         activeEmotion = 'all';
  //         if (currentEmotionSpan) {
  //           currentEmotionSpan.textContent = 'All';
  //         }
  //         applyFilters();
  //       }
  //     }, 0);
  //   });
  // }
  
  // Function to apply both filters (inclusive)
  function applyFilters() {
    entries.forEach(function(entry) {
      const entryColors = entry.getAttribute('data-color');
      const entryEmotions = entry.getAttribute('data-emotions');
      
      const colorMatch = activeColor === 'all' || (entryColors && entryColors.includes(activeColor.toLowerCase()));
      const emotionMatch = activeEmotion === 'all' || (entryEmotions && entryEmotions.includes(activeEmotion.toLowerCase()));
      
      if (colorMatch && emotionMatch) {
        entry.style.display = '';
      } else {
        entry.style.display = 'none';
      }
    });
  }
  
  // Lightbox functionality
  const lightbox = document.createElement('div');
  lightbox.id = 'innerworld-lightbox';
  lightbox.innerHTML = '<div class="lightbox-close"></div><div class="lightbox-content"><div class="lightbox-image"></div><div class="lightbox-caption uppercase"></div></div>';
  document.body.appendChild(lightbox);
  
  const lightboxImage = lightbox.querySelector('.lightbox-image');
  const lightboxCaption = lightbox.querySelector('.lightbox-caption');
  const lightboxClose = lightbox.querySelector('.lightbox-close');
  
  entries.forEach(function(entry) {
    entry.addEventListener('click', function() {
      const mediaElement = entry.querySelector('img, video');
      const caption = entry.getAttribute('data-caption');
      
      if (mediaElement) {
        const clonedMedia = mediaElement.cloneNode(true);
        lightboxImage.innerHTML = '';
        lightboxImage.appendChild(clonedMedia);
        
        // Add caption
        if (caption && caption !== '') {
          lightboxCaption.textContent = caption;
          lightboxCaption.style.display = 'block';
        } else {
          lightboxCaption.textContent = '';
          lightboxCaption.style.display = 'none';
        }
        
        lightbox.classList.add('show');
        document.body.classList.add('lightbox-open');
      }
    });
  });
  
  // Close lightbox
  lightboxClose.addEventListener('click', function() {
    lightbox.classList.remove('show');
    document.body.classList.remove('lightbox-open');
  });
  
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) {
      lightbox.classList.remove('show');
      document.body.classList.remove('lightbox-open');
    }
  });
  
  // Horizontal scroll with vertical wheel
  const foreground = document.getElementById('innerworld-foreground');
  
  if (foreground) {
    let animationFrameId = null;
    let autoScrollTimeout = null;
    let isUserScrolling = false;
    let isAutoScrolling = false;
    let lastScrollLeft = 0;
    let lastTimestamp = 0;
    
    // Auto scroll function using requestAnimationFrame for smooth animation
    function autoScrollStep(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const elapsed = timestamp - lastTimestamp;
      
      if (!isUserScrolling && elapsed > 0) {
        isAutoScrolling = true;
        // Scroll approximately 100 pixels per second (0.1 pixels per ms)
        const pixelsToScroll = (elapsed * 0.1);
        foreground.scrollLeft += pixelsToScroll;
        lastScrollLeft = foreground.scrollLeft;
        lastTimestamp = timestamp;
        isAutoScrolling = false;
      } else if (isUserScrolling) {
        lastTimestamp = timestamp;
      }
      
      animationFrameId = requestAnimationFrame(autoScrollStep);
    }
    
    function startAutoScroll() {
      if (animationFrameId) return;
      lastTimestamp = 0;
      animationFrameId = requestAnimationFrame(autoScrollStep);
    }
    
    // Stop auto scroll
    function stopAutoScroll() {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
        lastTimestamp = 0;
      }
    }
    
    // Handle manual scroll detection (works for both touch and wheel)
    let scrollTimeout = null;
    foreground.addEventListener('scroll', function() {
      // Ignore scroll events triggered by auto scroll
      if (isAutoScrolling) return;
      
      // Detect if user is manually scrolling
      const scrollDiff = Math.abs(foreground.scrollLeft - lastScrollLeft);
      if (scrollDiff > 2) {
        isUserScrolling = true;
        stopAutoScroll();
        
        // Clear existing timeout
        if (autoScrollTimeout) {
          clearTimeout(autoScrollTimeout);
        }
        
        // Clear scroll timeout
        if (scrollTimeout) {
          clearTimeout(scrollTimeout);
        }
        
        // Update lastScrollLeft after a brief delay
        scrollTimeout = setTimeout(function() {
          lastScrollLeft = foreground.scrollLeft;
        }, 50);
        
        // Resume auto scroll after 2 seconds of no manual scrolling
        autoScrollTimeout = setTimeout(function() {
          isUserScrolling = false;
          lastScrollLeft = foreground.scrollLeft;
          startAutoScroll();
        }, 100);
      }
    });
    
    // Handle wheel events for desktop
    foreground.addEventListener('wheel', function(e) {
      // Prevent default vertical scroll
      e.preventDefault();
      
      // Convert vertical scroll to horizontal
      const delta = e.deltaY || e.deltaX;
      foreground.scrollLeft += delta;
    }, { passive: false });
    
    // Handle touch events for mobile
    let touchStartX = 0;
    let touchStartScrollLeft = 0;
    
    foreground.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartScrollLeft = foreground.scrollLeft;
      isUserScrolling = true;
      stopAutoScroll();
    }, { passive: true });
    
    foreground.addEventListener('touchend', function() {
      // Clear existing timeout
      if (autoScrollTimeout) {
        clearTimeout(autoScrollTimeout);
      }
      
      // Resume auto scroll after 2 seconds
      autoScrollTimeout = setTimeout(function() {
        isUserScrolling = false;
        lastScrollLeft = foreground.scrollLeft;
        startAutoScroll();
      }, 100);
    }, { passive: true });
    
    // Start auto scroll on page load
    startAutoScroll();
  }
  
  // Background image rotation
  const backgroundImages = document.querySelectorAll('.background-image');
  
  if (backgroundImages.length > 1) {
    let currentIndex = 0;
    
    setInterval(function() {
      // Remove active class from current
      backgroundImages[currentIndex].classList.remove('active');
      
      // Move to next image
      currentIndex = (currentIndex + 1) % backgroundImages.length;
      
      // Add active class to next
      backgroundImages[currentIndex].classList.add('active');
    }, 6000);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_outerworld"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
setTimeout(function() {
  document.body.classList.add('show-swipers');  
}, 700);
 
const myCustomSlider = document.querySelectorAll('.article');

for( i=0; i< myCustomSlider.length; i++ ) {
  
  myCustomSlider[i].classList.add('article-' + i);
  myCustomSlider[i].querySelector('.article-swiper').classList.add('article-swiper-' + i);

  var mediaCount = parseInt(myCustomSlider[i].getAttribute('data-media-count')) || 0;
  var enableLoop = mediaCount > 3;

  var slider = new Swiper('.article-swiper-' + i, {
    loop: enableLoop,
    speed: 500,
    slidesPerView: 1.75,
    breakpoints: {
      820: {
        slidesPerView: 3,
        speed: 700,
      }
    },
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      prevEl: '.article-swiper-' + i + ' .button-prev',
      nextEl: '.article-swiper-' + i + ' .button-next',
    },
  });

}

$(document).off('click', '.swiper-slide-active .mobile-button-prev').on('click', '.swiper-slide-active .mobile-button-prev', function(event) {
  event.preventDefault();
  var swiperInstance = $(this).closest('.article-swiper')[0].swiper;
  swiperInstance.slidePrev();
});

$(document).off('click', '.swiper-slide-active .mobile-button-next').on('click', '.swiper-slide-active .mobile-button-next', function(event) {
  event.preventDefault();
  var swiperInstance = $(this).closest('.article-swiper')[0].swiper;
  swiperInstance.slideNext();
});

$(document).off('click', '.swiper-slide-prev .buttons').on('click', '.swiper-slide-prev .buttons', function(event) {
  event.preventDefault();
  var swiperInstance = $(this).closest('.article-swiper')[0].swiper;
  swiperInstance.slidePrev();
});

$(document).off('click', '.swiper-slide-next .buttons').on('click', '.swiper-slide-next .buttons', function(event) {
  event.preventDefault();
  var swiperInstance = $(this).closest('.article-swiper')[0].swiper;
  swiperInstance.slideNext();
});

// Index scroll functionality
const indexItems = document.querySelectorAll('.product-index-item');
const articles = document.querySelectorAll('.article');

// Click on index item to scroll to article
indexItems.forEach(function(item) {
  item.addEventListener('click', function() {
    const index = parseInt(item.getAttribute('data-index'));
    const targetArticle = document.querySelector('[data-article-index="' + index + '"]');
    console.log('Click', index);
    
    if (targetArticle) {
      document.querySelector('main').scrollTo({
        top: targetArticle.offsetTop,
        behavior: 'smooth'
      });
    }

    document.body.classList.remove('show-index');
  });
});

// Update active index item on scroll
document.querySelector('main').addEventListener('scroll', function() {
  const scrollPosition = document.querySelector('main').scrollTop + (window.innerHeight / 2);
  
  articles.forEach(function(article) {
    const articleTop = article.offsetTop;
    const articleBottom = articleTop + article.offsetHeight;
    const articleIndex = article.getAttribute('data-article-index');
    
    if (scrollPosition >= articleTop && scrollPosition < articleBottom) {
      // Remove active class from all items
      indexItems.forEach(function(item) {
        item.classList.remove('active');
      });
      
      // Add active class to current item
      const activeItem = document.querySelector('[data-index="' + articleIndex + '"]');
      if (activeItem) {
        activeItem.classList.add('active');
      }
    }
  });
});

// Filter functionality
const filters = document.querySelectorAll('.filter');
const currentFilterSpan = document.querySelector('.current-filter');
const filtersContainer = document.getElementById('filters-container');

filters.forEach(function(filter) {
  filter.addEventListener('click', function() {
    // Add hide-content class to body
    document.body.classList.add('hide-content');
    
    // Remove active class from all filters
    filters.forEach(function(f) {
      f.classList.remove('active');
    });
    
    // Add active class to clicked filter
    filter.classList.add('active');
    
    // Get filter text and value
    const filterText = filter.textContent;
    const filterValue = filter.getAttribute('data-value');
    const isAll = filter.classList.contains('all');
    
    // Update current filter text
    currentFilterSpan.textContent = filterText;
    
    // Close filters
    if (filtersContainer) {
      filtersContainer.classList.remove('show');
    }
    
    // Scroll to top
    document.body.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // Filter articles and index items after 300ms
    setTimeout(function() {
      articles.forEach(function(article) {
        const articleTags = article.getAttribute('data-tags');
        const articleIndex = article.getAttribute('data-article-index');
        const indexItem = document.querySelector('[data-index="' + articleIndex + '"]');
        
        if (isAll || (articleTags && articleTags.includes(filterValue))) {
          article.style.display = '';
          if (indexItem) {
            indexItem.style.display = '';
          }
        } else {
          article.style.display = 'none';
          if (indexItem) {
            indexItem.style.display = 'none';
          }
        }
      });
    }, 300);

    setTimeout(function() {
      document.body.classList.remove('hide-content');
    }, 600);
  });
});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_press"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const myCustomSlider = document.querySelectorAll('.module-press-container');

for( i=0; i< myCustomSlider.length; i++ ) {
  
  myCustomSlider[i].classList.add('module-press-container-' + i);
  myCustomSlider[i].querySelector('.module-press').classList.add('module-press-' + i);

  var slider = new Swiper('.module-press-' + i, {
    loop: true,
    speed: 500,
    breakpoints: {
      820: {
        speed: 1,
      }
    },
    navigation: {
      // prevEl: '.module-press-' + i + ' .button-prev',
      // nextEl: '.module-press-' + i + ' .button-next',
      nextEl: '.module-press-' + i,
    },
    pagination: {
      el: '.module-press-container-' + i + ' .press-pagination',
      clickable: true,
      type: 'fraction',
    },
  });

}
});

  } catch(e) { console.error(e); }
})();
})();
